import {takeEvery, call} from 'redux-saga/effects';
import {OTHER_FEEDBACK_GET} from '../constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';
import {Profile} from 'feedback-system/dto/IProfile';
import {Feedback} from 'feedback-system/dto/IFeedback';

function* otherFeedbackGetData(action: any) {

    const {recipientId, periodId, callbackOtherFeedback} = action;

    try {

        const otherFeedback = (yield call(Api.fetch, {
            endpoint: `feedback/recipient/${recipientId}/${periodId}`,
            method: ApiMethods.GET
        })).responseData;

        const autors = (yield call(Api.fetch, {
            endpoint: 'profiles/get',
            method: ApiMethods.POST,
            body: otherFeedback.map((fb: Feedback) => fb.authorId)
        })).responseData;

        const feedbackData = otherFeedback.map((fb: Feedback) => {
            const profile = autors.find((pr: Profile) => fb.authorId === pr.id);
            return {
                profile,
                feedback: fb
            };
        });

        callbackOtherFeedback(feedbackData);

    } catch (e) {
        callbackOtherFeedback(null);
    }
}

function* otherFeedbackSagaGet() {
    yield takeEvery(OTHER_FEEDBACK_GET, otherFeedbackGetData);
}

export default otherFeedbackSagaGet;
